import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { TemplatesCollectionEligibleQuery } from './TemplatesCollectionEligibleQuery.graphql';

export const preloadTemplatesCollectionEligible = () =>
	query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: TemplatesCollectionEligibleQuery,
	});
